import { trpc } from "../trpc";

export function useListFolderSubtreeMaxDepth(
  folderIds: string[] | undefined,
  options?: { ownerId?: string },
) {
  const normalizedFolderIds = [...new Set((folderIds ?? []).filter(Boolean))];
  const query = trpc.folder.listFolderSubtreeMaxDepth.useQuery(
    {
      folderIds: normalizedFolderIds,
      ...(options?.ownerId ? { ownerId: options.ownerId } : {}),
    },
    { enabled: normalizedFolderIds.length > 0 },
  );

  return {
    maxDepth: query.data?.maxDepth,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
